
export default {
    inserted(el, { value }) {
        const target = el.querySelector(value);
        if(target && target.offsetLeft + target.offsetWidth > el.offsetWidth) {
            el.scrollLeft = target.offsetLeft;
        }
    }
}
